import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';

import { CarouselNavigation } from 'components/carousel/CarouselNavigation';
import { CarouselItemMatcher } from 'components/carousel/shapes';
import { HorizontalNavigation } from 'components/HorizontalNavigation';

/**
 * Basic usage:
 *
 * <Carousel>
 *   <CarouselItem>One</CarouselItem>
 *   <CarouselItem>Two</CarouselItem>
 * </Carousel>
 */

export class Carousel extends Component {
  static propTypes = {
    children: CarouselItemMatcher,
    navigationNode: PropTypes.any.isRequired
  };

  constructor() {
    super();
    this.state = { activeIndex: 0 };
    this.activate = this.activate.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  activate(index) {
    this.setState({ activeIndex: index });
  }

  next() {
    const { activeIndex } = this.state;
    const nextIndex =
      activeIndex === this.props.children.length - 1 ? 0 : activeIndex + 1;
    this.activate(nextIndex);
  }

  previous() {
    const { activeIndex } = this.state;
    const previousIndex =
      activeIndex === 0 ? this.props.children.length - 1 : activeIndex - 1;
    this.activate(previousIndex);
  }

  render() {
    const indexedCarouselItems = this.props.children.map(
      (carouselItem, index) =>
        React.cloneElement(carouselItem, {
          key: carouselItem.title,
          index,
          activeIndex: this.state.activeIndex
        })
    );

    return (
      <div className='carousel'>
        <HorizontalNavigation onNext={this.next} onPrevious={this.previous}>
          <div className='carousel-items'>{indexedCarouselItems}</div>
        </HorizontalNavigation>
        <Portal node={this.props.navigationNode}>
          <CarouselNavigation activate={this.activate}>
            {indexedCarouselItems}
          </CarouselNavigation>
        </Portal>
      </div>
    );
  }
}
